import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_5 = { class: "svg-icon svg-icon-1 position-absolute ms-4" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "card-toolbar" }
const _hoisted_8 = {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_9 = {
  type: "button",
  class: "btn btn-light-primary me-3",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end"
}
const _hoisted_10 = { class: "svg-icon svg-icon-2" }
const _hoisted_11 = { class: "me-0" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_14 = {
  key: 1,
  class: "bi bi-three-dots fs-3"
}
const _hoisted_15 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold w-200px",
  "data-kt-menu": "true"
}
const _hoisted_16 = { class: "menu-item px-3" }
const _hoisted_17 = { class: "menu-content fs-6 text-dark fw-bolder px-3 py-4" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_19 = { class: "menu-item px-3" }
const _hoisted_20 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_21 = { class: "menu-item px-3" }
const _hoisted_22 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_23 = { class: "card-body pt-0" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "svg-icon svg-icon-2" }
const _hoisted_26 = {
  key: 1,
  class: "spinner-border spinner-border-sm align-middle"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_FilterDropdwon = _resolveComponent("FilterDropdwon")!
  const _component_MBDatatable = _resolveComponent("MBDatatable")!
  const _directive_auth = _resolveDirective("auth")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen021.svg" })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchItems())),
            class: "form-control form-control-solid w-250px ps-14",
            placeholder: _ctx.t('common.search')
          }, null, 40, _hoisted_6), [
            [_vModelText, _ctx.search]
          ]),
          _withDirectives(_createElementVNode("span", {
            class: "svg-icon svg-icon-1 position-absolute top-50 end-0 mr-2 translate-middle",
            style: {"cursor":"pointer"},
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeSearch && _ctx.removeSearch(...args)))
          }, [
            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
          ], 512), [
            [_vShow, _ctx.search != '']
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen031.svg" })
            ]),
            _createTextVNode(_toDisplayString(_ctx.t("common.filter")), 1)
          ]),
          _createVNode(_component_FilterDropdwon, {
            onSubmitFilter: _ctx.handleFilter,
            onResetFilter: _ctx.handleFilterReset
          }, null, 8, ["onSubmitFilter", "onResetFilter"]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("button", {
              class: "btn btn-icon btn-bg-light btn-active-color-primary",
              "data-kt-menu-trigger": "click",
              "data-kt-menu-placement": "bottom-end",
              "data-kt-menu-flip": "top-end",
              disabled: _ctx.disabledExportSelected || _ctx.loading || _ctx.disabledExportAll
            }, [
              (_ctx.disabledExportSelected || _ctx.disabledExportAll)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13))
                : (_openBlock(), _createElementBlock("i", _hoisted_14))
            ], 8, _hoisted_12),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.t("common.export")), 1)
              ]),
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", {
                  class: _normalizeClass(["menu-link px-3", { disabled: _ctx.disabledExportAll }]),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.filesExport(true))),
                  style: {"font-size":"normal"}
                }, [
                  (_ctx.disabledExportAll)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("common.downloadAll")) + "(" + _toDisplayString(_ctx.total) + ") ", 1)
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", {
                  class: _normalizeClass(["menu-link px-3", {
                    disabled:
                      _ctx.disabledExportSelected || _ctx.checkedInvoice.length === 0,
                  }]),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.filesExport(false))),
                  style: {"font-size":"normal"}
                }, [
                  (_ctx.disabledExportSelected)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("common.downloadSelected")) + "(" + _toDisplayString(_ctx.checkedInvoice.length) + ") ", 1)
                ], 2)
              ])
            ])
          ])), [
            [_directive_auth, { auth: ['export'] }]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createVNode(_component_MBDatatable, {
        loading: _ctx.loading,
        "table-data": _ctx.tableData,
        "table-header": _ctx.tableHeader,
        order: "desc",
        "enable-items-per-page-dropdown": true,
        "current-page": _ctx.currentPage,
        total: _ctx.total,
        "rows-per-page": _ctx.pageSize,
        selection: true,
        onSelectChange: _ctx.onRowsSelectChange,
        onCurrentChange: _ctx.onCurrentPageChange,
        onItemsPerPageChange: _ctx.onRowsPerPageChange,
        onSort: _ctx.onColumnSort
      }, {
        "cell-invoice_number": _withCtx(({ row: item }) => [
          _createTextVNode(_toDisplayString(item.invoice_number), 1)
        ]),
        "cell-created_at": _withCtx(({ row: item }) => [
          _createTextVNode(_toDisplayString(_ctx.formatUtcDate(item.created_at)), 1)
        ]),
        "cell-invoice_created_at": _withCtx(({ row: item }) => [
          _createTextVNode(_toDisplayString(_ctx.formatUtcDate(item.invoice_created_at)) + " " + _toDisplayString(item.invoice_ends_at
              ? " - " + _ctx.formatUtcDate(item.invoice_ends_at)
              : ""), 1)
        ]),
        "cell-type": _withCtx(({ row: item }) => [
          _createTextVNode(_toDisplayString(item.__show.type), 1)
        ]),
        "cell-total_net_amount": _withCtx(({ row: item }) => [
          _createTextVNode(_toDisplayString(item.currency == "EUR"
              ? _ctx.$currency.currency(item.total_net_amount, 2, ",", ".", "")
              : _ctx.$currency.currency(item.total_net_amount, 2, ".", "", "")), 1)
        ]),
        "cell-total_tax_amount": _withCtx(({ row: item }) => [
          _createTextVNode(_toDisplayString(item.currency == "EUR"
              ? _ctx.$currency.currency(item.total_tax_amount, 2, ",", ".", "")
              : _ctx.$currency.currency(item.total_tax_amount, 2, ".", "", "")), 1)
        ]),
        "cell-currency": _withCtx(({ row: item }) => [
          _createTextVNode(_toDisplayString(item.currency), 1)
        ]),
        "cell-actions": _withCtx(({ row: item }) => [
          _withDirectives((_openBlock(), _createElementBlock("button", {
            class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
            onClick: ($event: any) => (_ctx.fileExport(item.id, item))
          }, [
            _createElementVNode("span", _hoisted_25, [
              (!item.downloadDisabled)
                ? (_openBlock(), _createBlock(_component_inline_svg_icon, {
                    key: 0,
                    src: "media/icons/duotune/arrows/arr044.svg"
                  }))
                : (_openBlock(), _createElementBlock("span", _hoisted_26))
            ])
          ], 8, _hoisted_24)), [
            [_directive_auth, { auth: ['export'] }]
          ])
        ]),
        _: 1
      }, 8, ["loading", "table-data", "table-header", "current-page", "total", "rows-per-page", "onSelectChange", "onCurrentChange", "onItemsPerPageChange", "onSort"])
    ])
  ]))
}